import { render, staticRenderFns } from "./points_record_list.vue?vue&type=template&id=282d7192&scoped=true"
import script from "./points_record_list.vue?vue&type=script&lang=js"
export * from "./points_record_list.vue?vue&type=script&lang=js"
import style0 from "./points_record_list.vue?vue&type=style&index=0&id=282d7192&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d7192",
  null
  
)

export default component.exports